<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import RegisterView from '../../auth/components/RegisterView.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <RegisterView />
</template>